export default __webpack_public_path__ + "static/media/arrow.41d76395.svg";